<div
  class="mila-tree-item__row"
  [class.mila-tree-item__row--selected]="isSelected"
  [style.paddingLeft.px]="10 + depth * 16"
  (mousedown)="onSelect($event)"
>
  @if (item.hasChildren) {
    <span class="mila-tree-item__toggle" (mousedown)="toggleExpand($event)">
      @if (isLoading) {
        <span class="mila-tree-item__spinner" aria-hidden="true"></span>
      } @else {
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          @if (expanded) {
            <path d="M2 4L5 7L8 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          } @else {
            <path d="M4 2L7 5L4 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          }
        </svg>
      }
    </span>
  } @else {
    <span class="mila-tree-item__toggle mila-tree-item__toggle--spacer"></span>
  }

  <span class="mila-tree-item__label">{{ item.label }}</span>
</div>

@if (expanded && children?.length) {
  @for (child of children; track child.id) {
    <mila-multi-select-tree-item
      [item]="child"
      [fetchPage]="fetchPage"
      [selectedIds]="selectedIds"
      [depth]="depth + 1"
      (select)="onChildSelect($event)"
    ></mila-multi-select-tree-item>
  }
}
